import React from 'react';
import { Link } from 'react-router-dom';
import cx from 'classnames';

import { formatNumber as fn, formatMoney as fm, formatPercent as fp } from 'utils/utils';


const formatHours = v => (v ?? 0)/60 |> _.round(#, 1) |> `${#}h`
const formatSeconds = v => (v ?? 0)/1000 |> _.round(#, 0) |> `${#}s`
const formatMinutes = v => (v ?? 0)/1000/60 |> _.round(#, 0) |> `${#}m`

export const StatsBoxList = ({ className, size = 'm', align = 'row', rowCount = 4, wrap = true, children, ...props }) => (
  <div className={cx("g-stats", className, size, align, `row-${rowCount}`, { wrap })} {...props}>
    { children }
  </div>
);

export const StatsHeader = ({...props}) => <StatsBoxList align="row" rowCount="4" wrap={false} { ...props } />


export const StatLabel = ({ loading, ...props }) => <div className={cx("g-stat-label", { 'loading-text': loading })} {...props} />
export const StatValue = ({ loading, children, formatter = v => v, ...props }) => (
  <div className={cx("g-stat-value", { 'loading-text': loading })}>
    { !loading ? formatter(children) : null }
  </div>
)


export const StatBox = ({ label, value, loading, className, children, ...props }) => {
  return (
    <div className={ cx("g-stats-box", { loading }, className) }>
      <div className="wrapper">
        {loading &&
          <>
            <div className="label loading-text"></div>
            <div className="value loading-text"></div>
          </>}
        {!loading && 
          <>
            {label &&
            <div className="label">{label}</div>}
            <div className="value">{loading ? null : value}</div>
          </> }
      </div>
    </div>)
}
export default StatBox;



export const StatItemList = ({ className, size, loading, ...props }) => {
  return (
    <div className={cx("g-stat-item-list", className, size, { loading, })} {...props} />
  );
}

export const StatItem = ({ label, value, loading = false, size, className, formatter, quantileCount = 4, quantile, ...props }) => {
  let style = quantileCount && quantile ? { '--quantile': quantile } : null;
  return (
    <div className={cx("g-stat-item", { loading }, size, className)} style={style}>
      { label &&
      <StatLabel loading={loading}>{loading ? " " : label}</StatLabel>}
      <StatValue loading={loading} formatter={formatter}>{loading ? " " : value}</StatValue>
    </div>)
}
export const StatItemMoney = props => <StatItem {...props} formatter={v => `$${fm(v)}`} />
export const StatItemMoneySmall = props => <StatItem {...props} formatter={v => v === 0 ? `$0` : `$${fn(v, 2)}`} />
export const StatItemNumber = props => <StatItem {...props} formatter={fn} />
export const StatItemPercent = props => <StatItem {...props} formatter={fp} />
export const StatItemHours = props => <StatItem {...props} formatter={formatHours} />
export const StatItemMinutes = props => <StatItem {...props} formatter={formatMinutes} />
export const StatItemSeconds = props => <StatItem {...props} formatter={formatSeconds} />

